module.exports = "<ui-select ng-if=\"$ctrl.items\" id=\"$ctrl.id\" ng-model=\"$ctrl.ngModel\" on-select=\"$ctrl.onSelected($item)\" theme=\"bootstrap\" title=\"Please fill out this field.\">\n    <ui-select-match placeholder=\"{{$ctrl.placeholder}}\">{{$select.selected.name === undefined? 'Unable to retrieve country' : $select.selected.name}}</ui-select-match>\n    <ui-select-choices repeat=\"item.code as item in $ctrl.items | filter: $select.search\">\n        <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n    </ui-select-choices>\n</ui-select>";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/components/asCountry/asCountry.component.html
// module id = 705
// module chunks = 0